import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["dataHook", "disabled", "skin", "children", "size", "weight", "getClassName", "shouldTranslate", "prefixIcon", "suffixIcon", "underline", "as", "translateIfNeeded", "enableEllipsis", "customEllipsisProps"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import Text from '../text/text';
var BUTTON_SKINS = {
  STANDARD: 'standard',
  PREMIUM: 'premium',
  DARK: 'dark',
  AI: 'ai'
};
var BUTTON_SIZES = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
var BUTTON_WEIGHTS = {
  BOLD: 'bold',
  NORMAL: 'normal',
  THIN: 'thin'
};
var UNDERLINE_TYPE = {
  NONE: 'none',
  ALWAYS: 'always',
  ON_MOUSE_HOVER: 'onMouseHover'
};
var TextButton = /*#__PURE__*/function (_React$PureComponent) {
  function TextButton() {
    _classCallCheck(this, TextButton);
    return _callSuper(this, TextButton, arguments);
  }
  _inherits(TextButton, _React$PureComponent);
  return _createClass(TextButton, [{
    key: "_addAffix",
    value: function _addAffix(Affix, skin, disabled) {
      return Affix && /*#__PURE__*/React.createElement("span", {
        className: "control-text-button skin-".concat(skin),
        disabled: disabled
      }, Affix);
    }
  }, {
    key: "_getTextSkin",
    value: function _getTextSkin(skin) {
      switch (skin) {
        case BUTTON_SKINS.PREMIUM:
          {
            return 'premium';
          }
        case BUTTON_SKINS.STANDARD:
          {
            return 'link';
          }
        case BUTTON_SKINS.DARK:
          {
            return 'standard';
          }
        case BUTTON_SKINS.AI:
          {
            return 'ai';
          }
        default:
          {
            return 'link';
          }
      }
    }
  }, {
    key: "_getUnderlineClass",
    value: function _getUnderlineClass(underline) {
      switch (underline) {
        case UNDERLINE_TYPE.ALWAYS:
          {
            return 'always';
          }
        case UNDERLINE_TYPE.NONE:
          {
            return 'none';
          }
        case UNDERLINE_TYPE.ON_MOUSE_HOVER:
          {
            return 'on-mouse-hover';
          }
        default:
          {
            return 'on-mouse-hover';
          }
      }
    }
  }, {
    key: "_getTextButtonSkin",
    value: function _getTextButtonSkin(skin) {
      switch (skin) {
        case BUTTON_SKINS.AI:
          {
            return 'skin-ai';
          }
        default:
          {
            return '';
          }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        dataHook = _this$props.dataHook,
        disabled = _this$props.disabled,
        skin = _this$props.skin,
        children = _this$props.children,
        size = _this$props.size,
        weight = _this$props.weight,
        getClassName = _this$props.getClassName,
        shouldTranslate = _this$props.shouldTranslate,
        prefixIcon = _this$props.prefixIcon,
        suffixIcon = _this$props.suffixIcon,
        underline = _this$props.underline,
        Component = _this$props.as,
        translateIfNeeded = _this$props.translateIfNeeded,
        enableEllipsis = _this$props.enableEllipsis,
        customEllipsisProps = _this$props.customEllipsisProps,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var className = classNames(getClassName('control-text-button'), this._getUnderlineClass(underline), this._getTextButtonSkin(skin));
      var prefixClassName = getClassName('prefix');
      var suffixClassName = getClassName('suffix');
      return /*#__PURE__*/React.createElement(Component, _extends({
        "data-hook": dataHook,
        disabled: disabled
      }, rest, {
        className: className
      }), /*#__PURE__*/React.createElement("div", {
        className: prefixIcon && prefixClassName
      }, this._addAffix(prefixIcon, skin, disabled)), /*#__PURE__*/React.createElement(Text, {
        disabled: disabled,
        size: size,
        skin: this._getTextSkin(skin),
        weight: weight,
        shouldTranslate: shouldTranslate,
        enableEllipsis: enableEllipsis,
        customEllipsisProps: customEllipsisProps
      }, children), /*#__PURE__*/React.createElement("div", {
        className: suffixIcon && suffixClassName
      }, this._addAffix(suffixIcon, skin, disabled)));
    }
  }]);
}(React.PureComponent);
TextButton.displayName = displayNames.TEXT_BUTTON;
TextButton.propTypes = {
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** content to be displayed */
  children: PropTypes.any,
  /** Applies disabled styles and behaviour */
  disabled: PropTypes.bool,
  /** Triggered when button is clicked */
  onClick: PropTypes.func,
  /** Skin of TextButton  */
  skin: PropTypes.oneOf(Object.values(BUTTON_SKINS)),
  /** Size of TextButton */
  size: PropTypes.oneOf(Object.values(BUTTON_SIZES)),
  /** Weight of TextButton */
  weight: PropTypes.oneOf(Object.values(BUTTON_WEIGHTS)),
  /** Icon to be places before the text */
  prefixIcon: PropTypes.node,
  /** Icon to be places after the text */
  suffixIcon: PropTypes.node,
  /** Underline type of TextButton */
  underline: PropTypes.oneOf(Object.values(UNDERLINE_TYPE)),
  /** render as some other component or DOM tag */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string]),
  /** If false, the text breaks onto multiple lines (no ellipsis or tooltip) */
  enableEllipsis: PropTypes.bool,
  /** Custom props to override the default behavior of the wrapping <code>TooltipOnEllipsis</code> component */
  customEllipsisProps: PropTypes.object
};
TextButton.defaultProps = {
  as: 'button',
  skin: BUTTON_SKINS.STANDARD,
  size: BUTTON_SIZES.MEDIUM,
  weight: BUTTON_WEIGHTS.NORMAL,
  underline: UNDERLINE_TYPE.ON_MOUSE_HOVER,
  enableEllipsis: true
};
export default compose(TextButton);